import { a as d, j as i } from "../../../jsx-runtime-c20f6c15.mjs";
import s from "clsx";
import { useState as y, useRef as N, useEffect as f } from "react";
import b from "../../../shared/icons/chevron-up-outline.svg.mjs";
import j from "../InteractiveDiv/InteractiveDiv.mjs";
const O = "_container_1nv8o_1", x = "_header_1nv8o_6", A = "_disabled_1nv8o_10", I = "_titleContainer_1nv8o_14", P = "_caret_1nv8o_18", R = "_toggled_1nv8o_25", S = "_content_1nv8o_29", $ = "_openContent_1nv8o_45", k = "_closeContent_1nv8o_59", n = {
  container: O,
  header: x,
  disabled: A,
  titleContainer: I,
  caret: P,
  toggled: R,
  content: S,
  openContent: $,
  closeContent: k
};
function z({
  children: p,
  title: r,
  disabled: a,
  containerClassName: v,
  headerContainerClassName: m,
  contentContainerClassName: C,
  caretClassName: u,
  maxHeight: e = "1000px",
  expanded: o = !1,
  onToggle: l
}) {
  const [t, _] = y(o), c = N(null);
  function g() {
    _(!t), l && l(!t);
  }
  return f(() => {
    o !== t && _(o);
  }, [o]), f(() => {
    if (c.current)
      if (e != null) {
        const h = typeof e == "string" ? e : `${e}px`;
        c.current.style.setProperty(
          "--accordion-max-height",
          `${h}`
        );
      } else
        c.current.style.removeProperty("--accordion-max-height");
  }, [e]), /* @__PURE__ */ d("div", { className: s(n.container, v), children: [
    /* @__PURE__ */ d(
      j,
      {
        className: s(n.header, m, {
          [n.disabled]: a
        }),
        onClick: g,
        disabled: a,
        children: [
          typeof r == "string" ? /* @__PURE__ */ i("div", { className: n.titleContainer, children: r }) : r,
          /* @__PURE__ */ i(
            b,
            {
              className: s(n.caret, u, {
                [n.toggled]: t
              })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ i(
      "div",
      {
        ref: c,
        className: s(n.content, C, {
          [n.openContent]: t,
          [n.closeContent]: !t
        }),
        children: p
      }
    )
  ] });
}
export {
  z as default
};
